import { SyncConfigAPI } from '@weave/schema-gen-ts/dist/schemas/integrations/sync-config-api/v1/api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSyncConfigV1Service = bindHTTP(SyncConfigAPI);
export const serviceName = 'sync-config-v1' as const;
